export { setup as setupCheckout, createPayment, completePayment } from './checkout';
export { setup as setupProfile } from './profile-editor';
export { setup as setupPaymentHistory } from './payment-receipt';
export { setup as setupBuyNow } from './buy-now';
export {
	setupDownload as setupDownloadPRB,
	setupCheckout as setupCheckoutPRB,
} from './payment-request';
